import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  //#region properties
  loginForm: any = FormGroup;
  forgotPasswordForm: any = FormGroup;
  resetPasswordForm: any = FormGroup;
  registerForm: any = FormGroup;
  addInvestorForm: any = FormGroup;
  addVendorForm: any = FormGroup;
  userForm: any = FormGroup;
  investmentForm: any = FormGroup;
  paymentForm: any = FormGroup;
  programForm: any = FormGroup;
  tagsGroupForm: any = FormGroup;
  tagForm: any = FormGroup;
  cancelPaymentForm: any = FormGroup;
  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (
      control.value !== this.resetPasswordForm.controls.Password?.value
    ) {
      return { confirm: true, error: true };
    }
    return {};
  };
  confirmationValidatorRegisterForm = (
    control: FormControl
  ): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.registerForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };
  //#endregion

  //#region functions
  loginForm_fb() {
    this.loginForm = this._fb.group({
      Email: [
        null,
        [
          Validators.required,
          Validators.pattern(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/),
        ],
      ],
      Password: [null, [Validators.required]],
    });
  }

  addInvestorForm_fb() {
    this.addInvestorForm = this._fb.group({
      companyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      emailAddress: ['', [Validators.required, Validators.email]],
      phoneNumber: [''],
      streetAddress1: [''],
      streetAddress2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      country: [''],
      // isNonAlc: [true],
    });
  }

  addVendorForm_fb() {
    this.addVendorForm = this._fb.group({
      companyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      vendorDisplayName: ['', [Validators.pattern(/.*\S.*/)]],
      emailAddress: ['', [Validators.email]],
      phoneNumber: [''],
      streetAddress1: ['', Validators.required],
      streetAddress2: [''],
      internationalAddress: [''],
      // streetAddress: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zipCode: ['', Validators.required],
      country: ['', Validators.required],
    });
  }

  cancelPaymentForm_fb() {
    this.cancelPaymentForm = this._fb.group({
      reason: [null, [Validators.required]],
    });
  }

  forgotPasswordForm_fb() {
    this.forgotPasswordForm = this._fb.group({
      Email: [null, [Validators.required]],
    });
  }

  resetPasswordForm_fb() {
    this.resetPasswordForm = this._fb.group({
      Password: [null, [Validators.required]],
      ConfirmPassword: [
        null,
        [Validators.required, this.confirmationValidator],
      ],
    });
  }

  registerForm_fb() {
    this.registerForm = this._fb.group({
      supplierCode: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      companyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      mobileNumber: [null, [Validators.required]],
      emailAddress: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[\w+-.]+(\.[\w+-.]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/
          ),
        ],
      ],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)]],
      confirmPassword: ['', [this.confirmationValidatorRegisterForm]],
    });
  }

  userForm_fb() {
    this.userForm = this._fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: ['', Validators.required],
      role: ['', Validators.required],
      location: [''],
      title: [''],
      linkedinUrl: [
        '',
        Validators.pattern(
          /^(|https?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?)$/i
        ),
      ],
      phoneNumber: [''],
      sites: [''],
      isUserActive: [true],
    });
  }

  investmentForm_fb() {
    this.investmentForm = this._fb.group({
      investor: ['', Validators.required],
      programPeriod: ['', Validators.required],
      amount: ['', Validators.required],
      scheduledDate: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  paymentForm_fb() {
    this.paymentForm = this._fb.group({
      vendor: ['', Validators.required],
      programPeriod: ['', Validators.required],
      amount: ['', Validators.required],
      description: ['', Validators.required],
      invoiceNumber: ['', Validators.required],
      tags: ['', Validators.required],
      isNonAlc: [false],
    });
  }

  programForm_fb() {
    this.programForm = this._fb.group({
      label: ['', Validators.required],
      startMonth: ['', Validators.required],
      startYear: ['', Validators.required],
      endMonth: ['', Validators.required],
      endYear: ['', Validators.required],
      isVisible: [true],
    });
  }

  tagsGroupForm_fb() {
    this.tagsGroupForm = this._fb.group({
      tagGroupName: ['', Validators.required],
      // tagGroupColor: ['', Validators.required],
    });
  }

  tagForm_fb() {
    this.tagForm = this._fb.group({
      tagName: ['', Validators.required],
      tagGroup: ['', Validators.required],
    });
  }

  //#endregion
  constructor(private _fb: FormBuilder) { }
}
